import * as joint from '@joint/core'

/**
 * C4 Software System shape - rounded rectangle with labels
 */
export const C4SoftwareSystem = joint.dia.Element.define(
  'c4.SoftwareSystem',
  {
    size: { width: 240, height: 160 },
    attrs: {
      body: {
        refWidth: '100%',
        refHeight: '100%',
        rx: 10,
        ry: 10,
        fill: '#1168bd',
        stroke: '#0b4884',
        strokeWidth: 2,
      },
      nameLabel: {
        refX: '50%',
        refY: 30,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 14,
        fontWeight: 'bold',
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
      },
      typeLabel: {
        refX: '50%',
        refY: 50,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '[Software System]',
      },
      descriptionLabel: {
        refX: '50%',
        refY: 80,
        textVerticalAnchor: 'top',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
        textWrap: {
          width: '90%',
          height: 70,
          ellipsis: true,
        },
      },
    },
  },
  {
    markup: [
      {
        tagName: 'rect',
        selector: 'body',
      },
      {
        tagName: 'text',
        selector: 'nameLabel',
      },
      {
        tagName: 'text',
        selector: 'typeLabel',
      },
      {
        tagName: 'text',
        selector: 'descriptionLabel',
      },
    ],
  }
)

export function createSoftwareSystem(
  id: string,
  name: string,
  description: string = '',
  x: number = 0,
  y: number = 0,
  isExternal: boolean = false,
  style?: {
    background?: string
    stroke?: string
    color?: string
  }
): joint.dia.Element {
  // External systems are typically shown in gray
  const defaultBackground = isExternal ? '#999999' : '#1168bd'
  const defaultStroke = isExternal ? '#6b6b6b' : '#0b4884'

  const system = new C4SoftwareSystem({
    id,
    position: { x, y },
    attrs: {
      body: {
        fill: style?.background || defaultBackground,
        stroke: style?.stroke || defaultStroke,
      },
      nameLabel: {
        text: name,
        ...(style?.color && { fill: style.color }),
      },
      typeLabel: {
        text: isExternal ? '[Software System: External]' : '[Software System]',
        ...(style?.color && { fill: style.color }),
      },
      descriptionLabel: {
        text: description,
        ...(style?.color && { fill: style.color }),
      },
    },
  })

  return system
}
